import { Button, Flex } from "antd";

import styles from "../BrowserNotifyPrompt/browser-notify-prompt.module.css";
import {
  BLOCKED_INTRO,
  BLOCKED_TITLE,
  getBrowserInstruction,
} from "../browser";

/** Подсказка после отказа: как включить уведомления в настройках сайта. */
export default function DeniedHint({ browser, onClose }) {
  const titleId = "browser-notify-blocked-title";
  const introId = "browser-notify-blocked-intro";
  const instructionId = "browser-notify-blocked-instruction";

  return (
    <div
      className={styles.card}
      role="dialog"
      aria-labelledby={titleId}
      aria-describedby={`${introId} ${instructionId}`}
    >
      <h2 id={titleId} className={styles.title}>
        {BLOCKED_TITLE}
      </h2>
      <p id={introId} className={styles.text}>
        {BLOCKED_INTRO}
      </p>
      <p id={instructionId} className={styles.text}>
        {getBrowserInstruction(browser)}
      </p>
      <Flex justify="flex-end" className={styles.actions}>
        <Button type="primary" size="small" onClick={onClose}>
          Понятно
        </Button>
      </Flex>
    </div>
  );
}
